import { ImageDataLike } from "gatsby-plugin-image";

export type IPageSettings = {
  mobileFooterImage?: IImage;
};

export type IImage = {
  altText: string;
  gatsbyImage?: ImageDataLike;
  sourceUrl?: string;
  mimeType?: string;
  caption?: string;
};

export type ILink = {
  description?: string;
  link: any;
  title: string;
  target: string;
  url: string;
};

export enum Languages {
  English = "en",
  Swedish = "sv",
  Norwegian = "no"
}

export type ITranslation = {
  uri: string;
  language: {
    slug: Languages;
  };
};

export type IPostTypeContext = {
  date?: string;
  uri: string;
  language: {
    slug: Languages;
  };
  translations: ReadonlyArray<ITranslation>;
};

export type IExtraData = {
  title: string;
  description: string;
  location?: string;
  registration_url?: string;
  information_url?: string;
  datetime_from?: string;
  datetime_to?: string;
  is_invite_only?: boolean;
  slug?: string;
  url?: string;
  published_at?: string;
  image_url?: string;
};
